import type { JSX } from 'react';
import { Box } from '@ksyos/design-system';
import type { ChartLegendIconType } from './ChartLegendIcon';
import { ChartLegendIcon } from './ChartLegendIcon';

export interface LegendItem {
    icon: ChartLegendIconType;
    label: string;
}

interface LegendProps {
    legendItems: LegendItem[];
}

export function ChartLegend(props: LegendProps): JSX.Element {
    const { legendItems } = props;

    return (
        <ul
            style={{
                listStyle: 'none',
                margin: 0,
                padding: 0,
            }}
        >
            {legendItems.map((item) => (
                <Box
                    alignItems="center"
                    as="li"
                    display="flex"
                    flexDirection="row"
                    gap={3}
                    key={item.label}
                    mb={2}
                >
                    <Box
                        alignItems="center"
                        display="flex"
                        justifyContent="center"
                        width={33}
                    >
                        <ChartLegendIcon icon={item.icon} />
                    </Box>
                    <span
                        style={{
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {item.label}
                    </span>
                </Box>
            ))}
        </ul>
    );
}
